import { useEffect } from 'react'
import useTranslation from '@/hooks/useTranslation'

export default function usePageTitle(title) {
    const { t } = useTranslation()
    const suffix = t('pageTitle.suffix')

    useEffect(() => {
        document.title = title ? `${title} - ${suffix}` : suffix
    }, [title, suffix])
}
